import { Button } from '@/components/ui/button'
import { setActiveTab } from '@common-reducers/CampaignReducer'
import { boardsSelectByQuery, campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks"
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { Pencil } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

type Props = {
    campaignId?: string;
}

export default function CampaignSummaryAudienceDialog({ campaignId }: Props) {
    const dispatch = useAppDispatch()
    const { t } = useTranslation(namespace);

    let campaign
    const _campaign = useAppSelector((state) => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, { _id: campaignId }))
    const newCampaign = useAppSelector((state) => state.CampaignReducer.newCampaign)

    if (campaignId) campaign = _campaign
    else campaign = newCampaign


    let filteredboardArray = useAppSelector((state) => boardsSelectByQuery(state.DBBoardsReducer, {
        type: 'audience',
        $or: [
            { deleted: { $exists: false } },
            { deleted: false }
        ],
        _id: { $in: (campaign?.boardIDArray ?? []) }
    }))

    let selectedString = t('campaignSummary.noAudiencesSelected')

    if (campaign?.boardIDArray?.length === 1) {
        selectedString = t('campaignSummary.targetAudience')
    }
    else if ((campaign?.boardIDArray?.length ?? 0) > 1) {
        selectedString = t('campaignSummary.targetAudiencesCount', { count: campaign?.boardIDArray?.length })
    }

    return (
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 w-full">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-sky-600 dark:text-sky-400 flex items-center gap-2">
                    {selectedString}
                </h2>
                {!campaignId && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => dispatch(setActiveTab('audiences'))}
                        className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors h-8 w-8"
                    >
                        <Pencil className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                    </Button>
                )}
            </div>
            <div className="flex flex-wrap gap-2">
                {filteredboardArray && filteredboardArray.length !== 0 &&
                    filteredboardArray
                        .filter((label, index) => index < 3)
                        .map((audience, index) => {
                            return (
                                <span
                                    key={index}
                                    className={cn(
                                        "inline-block px-4 py-2 bg-sky-50 dark:bg-sky-950/40 text-sky-700 dark:text-sky-300 rounded-lg text-sm font-medium border border-sky-200 dark:border-sky-800"
                                    )}
                                >
                                    {audience.name}
                                </span>
                            )
                        })}
                {filteredboardArray.length > 3 && (
                    <span className="text-sm text-slate-600 dark:text-slate-400 flex items-center">
                        {t('campaignSummary.andMore', { count: filteredboardArray.length - 3 })}
                    </span>
                )}
            </div>
        </div>
    )
}